import { render, staticRenderFns } from "./ClassroomIndex.vue?vue&type=template&id=5f3453dd&scoped=true&"
import script from "./ClassroomIndex.vue?vue&type=script&lang=js&"
export * from "./ClassroomIndex.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomIndex.vue?vue&type=style&index=0&id=5f3453dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3453dd",
  null
  
)

export default component.exports